import { makeStyles, styled, SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon/SvgIcon";
import React from "react";

const viewBoxDimension = 1450;

const newViewBoxDimension = 512;

interface CustomSvgProps {
  iconColor?: string;
}

const CustomSvg = styled(({ iconColor, ...other }: CustomSvgProps & SvgIconProps) => <SvgIcon {...other} />)({
  "& .Swyft-icon, &.Swyft-icon": {
    stroke: (props: CustomSvgProps) => props.iconColor,
    fill: (props: CustomSvgProps) => props.iconColor
  }
});

export const MonthIcon: React.FC<SvgIconProps & CustomSvgProps> = React.forwardRef((props, ref) => {
  return (
    <CustomSvg
      {...props}
      ref={ref}
      viewBox={`0 0 ${viewBoxDimension} ${viewBoxDimension}`}
      className={`${props.className} Swyft-icon`}
      style={{
        strokeWidth: 40,
        fill: "none",
        strokeMiterlimit: 10,
        strokeLinejoin: "round",
        strokeLinecap: "round"
      }}
    >
      <g>
        <path
          d="M1283.9,330.5l26.9-23.5l-30.3-16.8c-10.1-6.7-16.8-20.2-10.1-30.3l13.5-33.6l-37-3.4
				c-13.5,0-23.5-10.1-23.5-23.5l-3.4-33.6l-33.6,13.5c-13.5,3.4-26.9,0-30.3-10.1l-16.8-30.3l-23.5,26.9
				c-10.1,10.1-23.5,10.1-33.6,3.4l-30.3-20.2l-10.1,33.6c-3.4,13.5-16.8,20.2-26.9,16.8l-33.6-6.7l6.7,33.6
				c3.4,13.5-6.7,23.5-16.8,26.9l-33.6,10.1l20.2,30.3c6.7,10.1,6.7,23.5-3.4,33.6l-26.9,23.5l30.3,16.8
				c10.1,6.7,16.8,20.2,10.1,30.3l-13.5,33.6l37,3.4c13.5,0,23.5,10.1,23.5,23.5l3.4,33.6l33.6-13.5c13.5-3.4,26.9,0,30.3,10.1
				l16.8,30.3l23.5-26.9c10.1-10.1,23.5-10.1,33.6-3.4l30.3,20.2l10.1-33.6c3.4-13.5,16.8-20.2,26.9-16.8l33.6,6.7l-6.7-33.6
				c-3.4-13.5,6.7-23.5,16.8-26.9l33.6-10.1l-20.2-30.3C1270.5,354,1273.9,340.6,1283.9,330.5z"
        />
        <ellipse cx="1115.4" cy="330.9" rx="111" ry="111" />
      </g>
      <g>
        <line x1="1142.7" y1="1127.6" x2="1142.7" y2="935.9" />
        <polyline points="1092.2,972.9 1142.7,1023.3 1196.5,972.9" />
        <line x1="1142.7" y1="1127.6" x2="1142.7" y2="1319.3" />
        <polyline points="1092.2,1285.6 1142.7,1231.8 1196.5,1285.6" />
        <line x1="1142.7" y1="1127.6" x2="977.9" y2="1033.4" />
        <polyline points="984.6,1093.9 1055.3,1077.1 1035.1,1006.5" />
        <line x1="1142.7" y1="1127.6" x2="1310.9" y2="1221.7" />
        <polyline points="1253.7,1252 1233.5,1181.4 1304.1,1161.2" />
        <line x1="1142.7" y1="1127.6" x2="1310.9" y2="1033.4" />
        <polyline points="1304.1,1093.9 1233.5,1077.1 1253.7,1006.5" />
        <line x1="1142.7" y1="1127.6" x2="977.9" y2="1221.7" />
        <polyline points="1035.1,1252 1055.3,1181.4 984.6,1161.2" />
      </g>
      <g>
        <path
          d="M355.7,1215c-13.5,0-23.5,10.1-23.5,23.5c0,16.8,16.8,33.6,37,33.6c26.9,0,43.7-20.2,43.7-47.1
				c0-37-26.9-74-90.8-74H123.7"
        />
        <path
          d="M480.2,1023.3c-13.5,0-23.5-10.1-23.5-23.5c0-16.8,13.5-33.6,33.6-33.6c26.9,0,47.1,20.2,47.1,47.1
				c0,37-26.9,67.3-80.7,67.3H248.1"
        />
        <path
          d="M349,946c-13.5,0-23.5-10.1-23.5-23.5c0-16.8,13.5-33.6,30.3-33.6c26.9,0,47.1,20.2,47.1,43.7
				c0,37-23.5,70.6-84.1,70.6h-148"
        />
      </g>
      <g>
        <g>
          <path
            d="M540.7,145.5c-97.5-23.5-208.5,3.4-285.9,80.7c-74,77.4-100.9,188.3-80.7,285.9
					c97.5,23.5,208.5-3.4,285.9-80.7c33.6-33.6,57.2-70.6,70.6-114.3"
          />
          <path d="M507.1,313.7c6.7-20.2,10.1-43.7,13.5-63.9c3.4-26.9,0-50.4-6.7-77.4" />
          <line x1="537.3" y1="152.3" x2="174.1" y2="512.1" />
          <line x1="530.6" y1="317.1" x2="369.2" y2="317.1" />
          <line x1="312" y1="374.2" x2="312" y2="189.3" />
          <line x1="466.7" y1="421.3" x2="268.3" y2="421.3" />
        </g>
      </g>
      <line x1="725.7" y1="48" x2="725.7" y2="1403.3" />
      <line x1="1401.7" y1="683.6" x2="49.7" y2="683.6" />
    </CustomSvg>
  );
});

export const InfoIcon: React.FC<SvgIconProps> = React.forwardRef((props, ref) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <path
        d="M11,7h2v2h-2V7z M11,11h2v6h-2V11z M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M12,20
      c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S16.4,20,12,20z"
      />
    </SvgIcon>
  );
});

export const CalendarIcon: React.FC<CustomSvgProps & SvgIconProps> = React.forwardRef((props, ref) => {
  return (
    <CustomSvg
      {...props}
      ref={ref}
      viewBox={`0 0 ${viewBoxDimension} ${viewBoxDimension}`}
      className={`${props.className} Swyft-icon`}
    >
      <g>
        <path
          d="M1108.7,303h38.3c79.2,0,143,66.4,145.6,145.6v658.9c0,81.7-66.4,145.6-145.6,145.6H304.3
				c-81.7,0-145.6-66.4-145.6-145.6V448.6c0-79.2,63.8-145.6,145.6-145.6h38.3v-79.2c0-12.8,10.2-25.5,25.5-25.5h132.8
				c12.8,0,25.5,10.2,25.5,25.5V303h398.4v-79.2c0-12.8,10.2-25.5,25.5-25.5h132.8c12.8,0,25.5,10.2,25.5,25.5L1108.7,303
				L1108.7,303z M396.2,252h79.2v117.5c0,23-17.9,38.3-38.3,38.3s-40.9-15.3-40.9-38.3L396.2,252L396.2,252z M1055.1,252h-76.6
				v117.5c0,20.4,15.3,38.3,38.3,38.3c20.4,0,38.3-15.3,38.3-38.3V252z M1147,1199.4c51.1,0,91.9-40.9,91.9-91.9h-2.6V448.6
				c0-51.1-40.9-91.9-91.9-91.9h-38.3v12.8c0,51.1-40.9,91.9-91.9,91.9c-51.1,0-91.9-40.9-91.9-91.9v-12.8H526.5v12.8
				c0,51.1-40.9,91.9-91.9,91.9s-91.9-40.9-91.9-91.9v-12.8h-38.3c-51.1,0-91.9,40.9-91.9,91.9V515h789.1
				c12.8,0,25.5,10.2,25.5,25.5c0,12.8-10.2,25.5-25.5,25.5H212.4v541.4c0,51.1,40.9,91.9,91.9,91.9L1147,1199.4L1147,1199.4z"
        />
      </g>
      <g>
        <path
          d="M1055.7,907.7H805.9c-6.6,0-12,5.4-12,12v203.6c0,6.6,5.4,12,12,12h249.8c6.6,0,12-5.4,12-12V919.7
		C1067.7,913.1,1062.3,907.7,1055.7,907.7z M1034.2,1095.4c0,6.6-5.4,12-12,12H839.3c-6.6,0-12-5.4-12-12v-148c0-6.6,5.4-12,12-12
		h182.9c6.6,0,12,5.4,12,12V1095.4z"
        />
      </g>
    </CustomSvg>
  );
});

export const DeleteIcon: React.FC<CustomSvgProps & SvgIconProps> = React.forwardRef((props, ref) => {
  return (
    <CustomSvg
      {...props}
      ref={ref}
      viewBox={`0 0 ${newViewBoxDimension} ${newViewBoxDimension}`}
      className={`${props.className} Swyft-icon`}
    >
      <path
        d="M352,21.3H96c-23.5,0-42.7,19.2-42.7,42.7v298.7H96V64h256V21.3z M416,106.7H181.3c-23.5,0-42.7,19.2-42.7,42.7
	V448c0,23.5,19.2,42.7,42.7,42.7H416c23.5,0,42.7-19.2,42.7-42.7V149.3C458.7,125.9,439.5,106.7,416,106.7z M416,448H181.3V149.3
	H416V448z"
      />
      <path
        d="M380,232.6l-16.1-16.1L300,280.4l-63.9-63.9L220,232.6l63.9,63.9L220,360.4l16.1,16.1l63.9-63.9l63.9,63.9
	l16.1-16.1l-63.9-63.9L380,232.6z"
      />
    </CustomSvg>
  );
});

export const GuaranteeIcon: React.FC<CustomSvgProps & SvgIconProps> = React.forwardRef((props, ref) => {
  return (
    <CustomSvg
      {...props}
      ref={ref}
      viewBox={`0 0 ${128} ${128}`}
      className={`${props.className} Swyft-icon`}
      style={{}}
    >
      <style>{".prefix__st11{fill:#292845}"}</style>
      <path
        className="prefix__st11"
        d="M119 48.75l-5.3-1.12c-.35-.06-.63-.28-.77-.57l-2.71-4.68-2.68 4.68c-.19.28-.47.5-.77.57l-5.3 1.12 3.62 4.02c.22.25.35.57.32.9l-.6 5.39 4.96-2.21c.16-.06.32-.09.47-.09.16 0 .35.03.47.09l4.96 2.21-.57-5.39c-.03-.35.06-.66.28-.9l3.62-4.02zM103.13 41.28l-7.74-1.65c-.32-.06-.6-.28-.74-.57l-3.96-6.82-3.92 6.82c-.16.28-.44.5-.74.57l-7.74 1.65 5.26 5.86c.22.25.35.57.28.9l-.8 7.83 7.2-3.18c.16-.09.32-.13.47-.13.19 0 .35.03.5.13l7.2 3.18-.8-7.83c-.06-.35.06-.66.28-.9l5.25-5.86zM80.06 33.8l-10.13-2.16c-.35-.06-.63-.28-.77-.57l-5.17-8.95-5.17 8.95c-.16.28-.44.5-.77.57L47.91 33.8l6.92 7.71c.22.25.35.6.32.9l-1.09 10.32 9.49-4.21a1.267 1.267 0 01.94 0l9.49 4.21-1.09-10.33c-.03-.32.09-.66.32-.9l6.85-7.7zM49.66 41.28l-7.71-1.65c-.35-.06-.63-.28-.77-.57l-3.92-6.82-3.96 6.82c-.16.28-.44.5-.74.57l-7.74 1.65 5.26 5.86c.22.25.35.57.32.9l-.84 7.83 7.23-3.18c.13-.09.32-.13.47-.13.16 0 .32.03.47.13l7.2 3.18-.8-7.83c-.03-.35.06-.66.28-.9l5.25-5.86zM26.49 48.75l-5.3-1.12c-.32-.06-.6-.28-.77-.57l-2.68-4.68-2.71 4.68c-.16.28-.44.5-.74.57L9 48.75l3.62 4.02c.22.25.32.57.28.9l-.57 5.39 4.96-2.21a1.267 1.267 0 01.94 0l4.96 2.21-.57-5.39c-.06-.35.06-.66.28-.9l3.59-4.02z"
      />
      <path
        d="M81.9 89.18c0-1.02-.41-1.97-.99-2.71.16-.13.32-.25.47-.41.8-.8 1.24-1.88 1.24-2.99 0-1.53-.87-2.55-1.18-2.93-1.62-1.91-4.3-1.97-7.9-1.88-1.75.03-3.4.13-5.06.22.47-1.28.84-2.58 1.12-3.99.47-2.68.47-5.52.03-8.16-.41-2.46-.99-3.5-1.56-4.24-.87-1.15-2.06-2.03-3.53-2.58l-.69-.13c-.63-.09-1.28.16-1.78.69-.38.41-.63.96-.72 1.69-.41 6.21-2.19 10.07-4.93 14.31-1.78 2.77-3.59 4.33-5.45 4.81v-1.43c0-.66-.54-1.18-1.15-1.18H37.65c-.63 0-1.15.54-1.15 1.18v25.26c0 .66.54 1.18 1.15 1.18h12.17c.63 0 1.15-.54 1.15-1.18v-1.02c4.93.84 13.79 2.17 20.9 2.17 1.59 0 3.06-.06 4.4-.19 1.09-.03 2.16-.47 2.93-1.24.77-.8 1.24-1.88 1.24-2.99 0-1.02-.41-1.97-1.02-2.71 1.06-.77 1.75-2 1.75-3.4 0-1.02-.41-1.97-1.02-2.71 1.06-.83 1.75-2.04 1.75-3.44z"
        fill="none"
        stroke="#292845"
        strokeWidth={5}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
    </CustomSvg>
  );
});

export const HeadsetIcon: React.FC<CustomSvgProps & SvgIconProps> = React.forwardRef((props, ref) => {
  return (
    <CustomSvg
      {...props}
      ref={ref}
      viewBox={`0 0 ${viewBoxDimension} ${viewBoxDimension}`}
      className={`${props.className} Swyft-icon`}
    >
      <g
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd"
        }}
      >
        <g>
          <g>
            <g>
              <path
                d="M323.9,1160.2c-18.2,0-33.9-14.5-33.9-33.8V681.5c0-18.1,14.5-33.8,33.9-33.8s33.9,14.5,33.9,33.8v446.1
                C356.6,1145.7,342.1,1160.2,323.9,1160.2z"
              />
              <path
                d="M288.8,1163.9c-117.5,0-213.1-95.5-213.1-212.8V844.7c0-117.3,95.7-212.8,213.1-212.8
                c8.5,0,18.2,0,26.6,1.2c18.2,2.4,31.5,19.3,29.1,37.5c-2.4,18.1-19.4,31.4-37.5,29c-6.1-1.2-12.1-1.2-18.2-1.2
                c-79.9,0-146.5,65.3-146.5,146.3v107.6c0,79.8,65.4,146.3,146.5,146.3h13.3c18.2-1.2,35.1,12.1,36.3,30.2
                c1.2,18.1-12.1,35.1-30.3,36.3C302.1,1163.9,294.8,1163.9,288.8,1163.9z"
              />
            </g>
            <g>
              <path
                d="M1111,1160.2c-18.2,0-33.9-14.5-33.9-33.8V681.5c0-18.1,14.5-33.8,33.9-33.8c18.2,0,33.9,14.5,33.9,33.8
                v446.1C1144.9,1145.7,1130.4,1160.2,1111,1160.2z"
              />
              <path
                d="M1146.1,1163.9c-6.1,0-13.3,0-19.4-1.2c-18.2-1.2-31.5-18.1-30.3-36.3c1.2-18.1,18.2-31.4,36.3-30.2h13.3
                c79.9,0,146.5-65.3,146.5-146.3V844.7c0-79.8-65.4-146.3-146.5-146.3c-6.1,0-12.1,0-18.2,1.2c-18.2,2.4-35.1-10.9-37.5-29
                s10.9-35.1,29.1-37.5c8.5-1.2,18.2-1.2,26.6-1.2c117.5,0,213.1,95.5,213.1,212.8v107.6
                C1359.2,1068.4,1263.6,1163.9,1146.1,1163.9L1146.1,1163.9z"
              />
            </g>
            <path
              d="M190.7,693.6h-3.6c-18.2-1.2-31.5-18.1-30.3-36.3c13.3-136.6,76.3-263.5,178-356.6
              c101.7-93,234.9-145,374.2-145s271.2,52,374.2,145.1c101.7,93.1,164.7,218.8,178,355.4c1.2,18.1-12.1,35.1-30.3,36.3
              c-18.2,1.2-35.1-12.1-36.3-30.2c-23-251.4-232.5-440-484.4-440c-253.1,0-461.4,189.8-484.4,441.2
              C222.2,680.3,207.7,693.6,190.7,693.6L190.7,693.6z"
            />
            <path
              d="M1104.9,671.9c-15.7,0-29.1-10.9-32.7-26.6c-18.2-77.4-55.7-147.5-109-201.9c-13.3-13.3-12.1-33.8,0-47.1
              c13.3-13.3,33.9-12.1,47.2,0c61.8,64.1,106.6,145.1,127.1,234.5c3.6,18.1-7.3,36.3-25.4,39.9
              C1109.8,670.7,1107.4,671.9,1104.9,671.9L1104.9,671.9z"
            />
            <path
              d="M923.3,395.1c-12.1,0-23-6-29.1-16.9l29.1-16.9v-33.8c7.3,0,13.3,2.4,18.2,4.8c8.5,6,14.5,15.7,15.7,27.8
              C956,380.6,941.5,395.1,923.3,395.1z"
            />
            <path
              d="M308.2,663.4c-2.4,0-4.8,0-8.5-1.2c-18.2-4.8-29.1-23-24.2-41.1c52-209.1,228.8-355.4,429.8-355.4
              c49.6,0,99.3,8.5,146.5,26.6c17,6,26.6,25.4,19.4,43.5c-6.1,16.9-25.4,26.6-43.6,19.3c-38.7-14.5-81.1-21.8-122.3-21.8
              C535.8,332.2,385.7,457.9,340.8,638C337.2,652.5,323.9,663.4,308.2,663.4L308.2,663.4z"
            />
          </g>
          <path
            d="M857.9,1218.3c-18.2,0-33.9-14.5-33.9-33.8c0-18.1,14.5-33.8,33.9-33.8c159.8,0,213.1-105.2,215.5-110
            c8.5-16.9,27.9-24.2,44.8-15.7c17,7.3,24.2,27.8,15.7,44.7C1130.4,1075.6,1062.5,1218.3,857.9,1218.3L857.9,1218.3z"
          />
          <path
            d="M666.6,1295.6H761c61.8,0,110.2-49.6,110.2-110v-1.2c0-60.4-49.6-110-110.2-110h-94.5
            c-60.5,0-110.2,49.6-110.2,110v1.2C556.4,1246.1,606,1295.6,666.6,1295.6z M623,1184.4c0-24.2,19.4-43.5,43.6-43.5H761
            c24.2,0,43.6,19.3,43.6,43.5v1.2c0,24.2-19.4,43.5-43.6,43.5h-94.5c-24.2,0-43.6-19.3-43.6-43.5L623,1184.4L623,1184.4z"
          />
        </g>
      </g>
    </CustomSvg>
  );
});

export const InstallMaskIcon: React.FC<CustomSvgProps & SvgIconProps> = React.forwardRef((props, ref) => {
  return (
    <CustomSvg
      {...props}
      ref={ref}
      viewBox={`0 0 ${viewBoxDimension} ${viewBoxDimension}`}
      className={`${props.className} Swyft-icon`}
    >
      <g
        style={{
          fill: "none",
          strokeWidth: 40,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }}
      >
        <line x1="974.9" y1="1128" x2="974.9" y2="1377.6" />
        <line x1="475.7" y1="1128" x2="475.7" y2="1377.6" />
        <path
          d="M1058.1,710.5h55.4v138.9l-55.4,56.6v27.8c1,48-8.4,95.7-27.5,139.8c-34.5,39.5-71.6,76.5-111,111
        c-37.3,35.9-87.1,55.8-138.9,55.7H670c-51.8,0.1-101.5-19.8-138.9-55.7c-39.5-34.5-76.5-71.6-111-111
        c-19.2-44.1-28.6-91.7-27.5-139.8V906l-55.4-55.4V710.5h55.4"
        />
        <polyline points="642.1,323.3 642.1,73.7 808.5,73.7 808.5,323.3" />
        <line x1="1197" y1="628.5" x2="253.7" y2="628.5" />
        <path d="M558.9,240.1V101.5c-131.9,43.9-222,137.4-222,276.2v111.9l-55.4,27.8v55.7" />
        <path d="M891.7,240.1V101.5c131.9,43.9,222.1,137.4,222.1,277.4v110.7l55.4,27.8v55.7" />
      </g>
      <g
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd"
        }}
      >
        <path
          d="M930.9,901.8c25.1-18,57.8-21.6,86.3-9.5c33.9,13.6,56,46.4,55.6,82.8c-0.1,31.5-16.7,60.6-43.7,76.9
        l-97.7,58.3v20.2c0,5.6-3.4,10.7-8.6,12.9c-130,55.2-277.1,55.2-407.1,0c-5.2-2.2-8.6-7.3-8.6-12.9v-20.2l-97.7-58.3
        c-27.1-16.3-43.6-45.4-43.7-76.9c0-33.5,18.7-64.1,48.6-79.5c29.8-15.4,65.8-13,93.3,6.3c1-4,3.7-7.3,7.4-9.2
        c3.7-1.8,8-1.9,11.8-0.3c122.9,52.1,261.9,52.1,384.8,0c3.8-1.6,8.1-1.5,11.8,0.3C927.1,894.4,929.9,897.8,930.9,901.8z
         M423.9,1027.7l83.1,49.6V939.2l-7.7-7.6c-17.7-17.6-44.2-22.8-67.3-13.3c-23.1,9.5-38.1,31.9-38.1,56.8
        C394,996.6,405.4,1016.6,423.9,1027.7z M931.3,1077.4l83.1-49.6c18.6-11.2,29.9-31.1,30-52.7c0-24.9-15.1-47.3-38.1-56.8
        c-23.1-9.5-49.7-4.3-67.3,13.3l-7.7,7.6L931.3,1077.4L931.3,1077.4z M903,926.1V1121c-117.9,47.4-249.8,47.4-367.7,0V926.1
        C653.8,970.7,784.6,970.7,903,926.1z"
        />
        <path
          d="M648.5,1045.9c0,7.8,6.3,14.1,14.1,14.1h113.1c7.8,0,14.1-6.3,14.1-14.1s-6.3-14.1-14.1-14.1H662.6
        C654.8,1031.9,648.5,1038.2,648.5,1045.9z"
        />
        <path
          d="M775.8,1088.2H662.6c-7.8,0-14.1,6.3-14.1,14.1s6.3,14.1,14.1,14.1h113.1c7.8,0,14.1-6.3,14.1-14.1
        S783.6,1088.2,775.8,1088.2z"
        />
      </g>
    </CustomSvg>
  );
});

export const InstallerIcon: React.FC<CustomSvgProps & SvgIconProps> = React.forwardRef((props, ref) => {
  return (
    <CustomSvg {...props} ref={ref} viewBox={`0 0 ${128} ${128}`} className={`${props.className} Swyft-icon`}>
      <style>
        {
          ".prefix__st122{fill:none;stroke:#292845;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}"
        }
      </style>
      <path
        className="prefix__st122"
        d="M85.18 98.12v21.17M42.82 98.12v21.17M92.24 62.82h4.71v11.76l-4.71 4.71v2.35c0 3.08-.74 9.34-2.35 11.76-1.62 2.43-9.41 9.41-9.41 9.41-3.36 3.22-7.65 4.71-11.76 4.71h-9.43c-4.12 0-8.4-1.48-11.76-4.71 0 0-7.79-6.99-9.41-9.41-1.62-2.43-2.35-8.69-2.35-11.76v-2.35l-4.71-4.71V62.82h4.71M56.94 29.88V8.71h14.12v21.17M104 55.76H24M49.88 22.82V11.06C38.7 14.79 31.06 22.72 31.06 34.59V44l-4.71 2.35v4.71M78.12 22.82V11.06c11.18 3.73 18.82 11.66 18.82 23.53V44l4.71 2.35v4.71"
      />
    </CustomSvg>
  );
});

export const AccountManagerIcon: React.FC<CustomSvgProps & SvgIconProps> = React.forwardRef((props, ref) => {
  return (
    <CustomSvg {...props} ref={ref} viewBox={`0 0 ${150} ${150}`} className={`${props.className} Swyft-icon`}>
      <g
        transform="translate(5.000000, 13.000000)"
        fill="none"
        strokeWidth="6"
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd"
        }}
      >
        <path d="M15.5136163,85.5844958 L5.41464577,83.8961471 C2.28951494,83.3738223 0,80.6693523 0,77.5011698 L0,57.9256615 C0,54.9519893 2.02238757,52.3600758 4.90684443,51.6364978 L15.5136163,48.9766354 L15.5136163,85.5844958 Z"></path>
        <path d="M79.642857,83.1953916 C79.642857,88.6121122 75.2515943,93.0033748 69.8348738,93.0033748 C64.4181532,93.0033748 60.0268906,88.6121122 60.0268906,83.1953916"></path>
        <path d="M45.69211,68.671962 C45.69211,65.13032 48.5635995,62.2588305 52.1052415,62.2588305 C55.6468836,62.2588305 58.5178544,65.13032 58.5178544,68.671962"></path>
        <path d="M81.1518413,68.671962 C81.1518413,65.13032 84.0228122,62.2588305 87.5649729,62.2588305 C91.1066149,62.2588305 93.9775858,65.13032 93.9775858,68.671962"></path>
        <path d="M57.7635697,23.7184722 L57.7635697,29.6834522 C57.7635697,40.4261219 66.4719218,49.134474 77.2145915,49.134474 L112.084827,49.134474"></path>
        <path d="M57.7635697,23.7184722 L57.7635697,29.6834522 C57.7635697,40.4261219 49.0552176,49.134474 38.3125479,49.134474 L27.5849204,49.134474"></path>
        <path d="M27.5873582,46.5397077 L27.5873582,68.5323296 C27.5873582,80.1899754 32.3204402,90.7583638 39.9582081,98.4090991 C45.5730697,104.023961 52.7699478,108.069773 60.8226708,109.79443"></path>
        <path d="M112.082597,46.5397077 L112.082597,65.9388601 C112.082597,81.8886979 105.884205,93.7927232 96.2105631,101.53423"></path>
        <path d="M92.4688608,124.486539 L77.3795361,124.486539 C73.2128679,124.486539 69.8351331,121.108805 69.8351331,116.941618 C69.8351331,112.774949 73.2128679,109.397215 77.3795361,109.397215 L92.4688608,109.397215 C96.635529,109.397215 100.013264,112.774949 100.013264,116.941618 C100.013264,121.108805 96.635529,124.486539 92.4688608,124.486539 Z"></path>
        <path d="M124.486384,48.976791 L134.585354,50.6651397 C137.710485,51.1874645 140,53.8919346 140,57.060117 L140,76.6356253 C140,79.6092975 137.977612,82.201211 135.093156,82.924789 L124.486384,85.5846514"></path>
        <path d="M15.5147574,85.5844958 L15.5147574,54.3202201 C15.5147574,39.3169987 21.5964435,25.7401855 31.4256932,15.9109358 C41.2549429,6.08168614 54.8317561,0 69.8349775,0 C99.8414205,0 124.155198,24.3267446 124.155198,54.3202201 L124.155198,91.2901288 C124.155198,109.625959 109.294617,124.486539 90.9587872,124.486539"></path>
      </g>
    </CustomSvg>
  );
});

export const MaskIcon: React.FC<CustomSvgProps & SvgIconProps> = React.forwardRef((props, ref) => {
  return (
    <CustomSvg
      {...props}
      ref={ref}
      viewBox={`0 0 ${viewBoxDimension} ${viewBoxDimension}`}
      className={`${props.className} Swyft-icon`}
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd"
      }}
    >
      <path
        d="M1116.2,480c46.3-33.2,106.6-39.8,159.1-17.6c62.5,25,103.3,85.7,102.6,152.7c-0.2,58-30.7,111.8-80.7,141.8
			L1117,864.5v37.2c0,10.4-6.2,19.8-15.8,23.9c-239.9,101.8-511.1,101.8-751,0c-9.6-4.1-15.8-13.5-15.8-23.9v-37.2L154.1,756.9
			c-49.9-30-80.5-83.7-80.7-141.8c0-61.7,34.5-118.3,89.6-146.7c55-28.4,121.4-24,172.1,11.6c1.9-7.4,6.9-13.5,13.7-16.9
			c6.8-3.4,14.8-3.6,21.8-0.6c226.8,96.2,483.1,96.2,709.9,0c7-3,15-2.8,21.8,0.6C1109.3,466.5,1114.3,472.6,1116.2,480z M181,712.4
			L334.4,804V549l-14.2-14c-32.6-32.4-81.6-42.1-124.2-24.6c-42.6,17.6-70.3,58.9-70.4,104.8C125.8,655,146.8,691.8,181,712.4z
			 M1117,804l153.4-91.6c34.2-20.6,55.2-57.4,55.3-97.2c0-45.9-27.8-87.2-70.4-104.8s-91.6-7.9-124.2,24.6l-14.1,14V804z
			 M1064.8,524.9v359.6c-217.5,87.5-460.7,87.5-678.3,0V524.9C605.1,607.1,846.3,607.1,1064.8,524.9z"
      />
      <path
        d="M595.2,746c0,14.3,11.7,26,26.1,26H830c14.4,0,26.1-11.6,26.1-26s-11.7-26-26.1-26H621.3
			C606.9,720,595.2,731.6,595.2,746z"
      />
      <path
        d="M830,823.8H621.3c-14.4,0-26.1,11.6-26.1,26c0,14.3,11.7,26,26.1,26H830c14.4,0,26.1-11.6,26.1-26
			C856.1,835.5,844.4,823.8,830,823.8z"
      />
    </CustomSvg>
  );
});

export const MobileChatIcon: React.FC<CustomSvgProps & SvgIconProps> = React.forwardRef((props, ref) => {
  return (
    <CustomSvg
      {...props}
      ref={ref}
      viewBox={`0 0 ${viewBoxDimension} ${viewBoxDimension}`}
      className={`${props.className} Swyft-icon`}
    >
      <g
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd"
        }}
      >
        <path
          d="M1154.5,877.3H776.7v-55.2h377.8c5.5,0,8.3-2.8,8.3-2.8V408.5c0-2.8-5.5-5.5-8.3-5.5H638.8
              c-2.8,0-8.3,0-8.3,5.5v410.9c0,0,0,2.8,8.3,2.8h93.8v55.2h-93.8c-35.8,0-63.4-24.8-63.4-60.7V408.5c0-33.1,27.6-60.7,63.4-60.7
              h515.7c35.8,0,66.2,27.6,66.2,60.7v410.9C1220.7,852.5,1190.3,877.3,1154.5,877.3z"
        />
        <path
          d="M716,1001.4c-8.3,0-16.5-2.8-22.1-11c-8.3-13.8-5.5-30.3,5.5-38.6L856.7,836c13.8-8.3,30.3-5.5,38.6,5.5
              c8.3,13.8,5.5,30.3-5.5,38.6L732.6,995.9C727,1001.4,721.5,1001.4,716,1001.4z"
        />
        <path
          d="M710.5,1007c-16.5,0-27.6-11-27.6-27.6l-2.8-124.1c0-16.5,11-27.6,27.6-27.6s27.6,11,27.6,27.6l2.8,124.1
              C738.1,993.2,727,1007,710.5,1007z"
        />
      </g>
      <g>
        <path
          d="M765.7,1335.1H368.5c-74.5,0-137.9-60.7-137.9-137.9V254.1c0-74.5,60.7-137.9,137.9-137.9h397.1
              c74.5,0,137.9,60.7,137.9,137.9v60.7h-55.2v-60.7c-2.8-44.1-38.6-82.7-82.7-82.7H368.5c-44.1,0-82.7,38.6-82.7,82.7V1200
              c0,44.1,35.8,80,80,80h397.1c44.1,0,80-35.8,80-80V935.3H898V1200C903.5,1274.4,840.1,1335.1,765.7,1335.1z"
        />
        <rect x="305.1" y="278.9" width="512.9" height="55.2" />
        <path
          d="M804.3,1100.7H324.4c-16.5,0-27.6-13.8-27.6-27.6s13.8-27.6,27.6-27.6h479.8c16.5,0,27.6,13.8,27.6,27.6
              S820.8,1100.7,804.3,1100.7z"
        />
        <path
          d="M641.6,1213.8h-149c-16.5,0-27.6-13.8-27.6-27.6c0-16.5,13.8-27.6,27.6-27.6h148.9
              c16.5,0,27.6,13.8,27.6,27.6S655.3,1213.8,641.6,1213.8z"
        />
      </g>
      <g>
        <rect x="727" y="472" width="350.2" height="55.2" />
        <rect x="727" y="579.5" width="350.2" height="55.2" />
        <rect x="727" y="687.1" width="284" height="55.2" />
      </g>
    </CustomSvg>
  );
});

const quoteIconStyles = makeStyles((theme) => ({
  st1: {},
  st2: {
    fillRule: "evenodd",
    clipRrule: "evenodd"
  },
  st3: {
    fillRule: "evenodd",
    clipRrule: "evenodd",
    fill: "#010101",
    fillOpacity: 0,
    strokeWidth: 0.5,
    strokeDasharray: "0,0,0,0"
  },
  st13: {
    stroke: "#010101",
    strokeMiterlimit: 10,
    fill: "#292845"
  }
}));

export const QuoteIcon: React.FC<CustomSvgProps & SvgIconProps> = React.forwardRef((props, ref) => {
  const classes = quoteIconStyles();

  return (
    <CustomSvg
      {...props}
      ref={ref}
      viewBox={`0 0 ${viewBoxDimension} ${viewBoxDimension}`}
      className={`${props.className} Swyft-icon`}
    >
      <g id="Layer_7">
        <g>
          <g>
            <g>
              <rect x="1229.1" y="261.9" className={classes.st1} width="58.3" height="84.2" />
              <path
                className={classes.st2}
                d="M830.9,1433.9h-667V57.9h1120.2v158.6h-55V116.2H222.2v1262.7h608.7V1433.9L830.9,1433.9z"
              />
              <path
                className={classes.st2}
                d="M976.6,1433.9h-97.1v-55h42.1v-336.7h307.6V462.6h55v637.8l-307.6-3.2V1433.9z"
              />
              <path
                className={classes.st2}
                d="M966.9,1433.9c-6.5,0-13-3.2-19.4-6.5c-13-9.7-13-29.1,0-38.9l288.2-307.6c9.7-13,29.1-13,38.9,0
              c13,9.7,13,29.1,0,38.9l-288.2,307.6C983.1,1430.6,976.6,1433.9,966.9,1433.9z"
              />
              <rect x="516.8" y="809" className={classes.st1} width="550.4" height="58.3" />
              <rect x="500.7" y="689.2" className={classes.st1} width="569.8" height="58.3" />
              <rect x="403.5" y="689.2" className={classes.st1} width="58.3" height="51.8" />
              <rect x="403.5" y="815.5" className={classes.st1} width="58.3" height="51.8" />
              <rect x="503.9" y="928.8" className={classes.st1} width="569.8" height="58.3" />
              <rect x="403.5" y="928.8" className={classes.st1} width="58.3" height="51.8" />
              <g>
                <rect x="500.7" y="1048.6" className={classes.st1} width="385.3" height="58.3" />
                <rect x="403.5" y="1048.6" className={classes.st1} width="58.3" height="51.8" />
              </g>
            </g>
            <g>
              <g>
                <g>
                  <path
                    id="path-15"
                    className={classes.st2}
                    d="M617.2,550h239.6c3.2,0,6.5-3.2,6.5-6.5V265.1c0-3.2-3.2-6.5-6.5-6.5H617.2
                  c-3.2,0-6.5,3.2-6.5,6.5v278.4C610.7,546.8,614,550,617.2,550z M850.3,537.1H620.4V271.6h229.9L850.3,537.1L850.3,537.1z"
                  />
                </g>
                <g>
                  <path
                    id="path-15_1_"
                    className={classes.st3}
                    d="M617.2,550h239.6c3.2,0,6.5-3.2,6.5-6.5V265.1c0-3.2-3.2-6.5-6.5-6.5H617.2
                  c-3.2,0-6.5,3.2-6.5,6.5v278.4C610.7,546.8,614,550,617.2,550z M850.3,537.1H620.4V271.6h229.9L850.3,537.1L850.3,537.1z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    id="path-16"
                    className={classes.st2}
                    d="M856.8,268.3h-3.2c0,0-51.8-35.6-110.1-35.6c-68,0-126.3,35.6-126.3,35.6
                  c-3.2,3.2-6.5,0-9.7-3.2s0-6.5,3.2-9.7c3.2,0,58.3-35.6,129.5-35.6h3.2c61.5,0,113.3,35.6,116.6,38.9c3.2,3.2,3.2,6.5,0,9.7
                  L856.8,268.3L856.8,268.3z"
                  />
                </g>
                <g>
                  <path
                    id="path-16_1_"
                    className={classes.st3}
                    d="M856.8,268.3h-3.2c0,0-51.8-35.6-110.1-35.6c-68,0-126.3,35.6-126.3,35.6
                  c-3.2,3.2-6.5,0-9.7-3.2s0-6.5,3.2-9.7c3.2,0,58.3-35.6,129.5-35.6h3.2c61.5,0,113.3,35.6,116.6,38.9c3.2,3.2,3.2,6.5,0,9.7
                  L856.8,268.3L856.8,268.3z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    id="path-17"
                    className={classes.st2}
                    d="M737,585.6c-84.2,0-123-32.4-123-32.4c-3.2-3.2-3.2-6.5,0-9.7s6.5-3.2,9.7,0
                  c0,0,35.6,29.1,116.6,29.1c77.7,0,116.6-29.1,116.6-29.1c3.2-3.2,6.5,0,9.7,0c3.2,3.2,0,6.5,0,9.7
                  C860,553.2,817.9,585.6,737,585.6z"
                  />
                </g>
                <g>
                  <path
                    id="path-17_1_"
                    className={classes.st3}
                    d="M737,585.6c-84.2,0-123-32.4-123-32.4c-3.2-3.2-3.2-6.5,0-9.7s6.5-3.2,9.7,0
                  c0,0,35.6,29.1,116.6,29.1c77.7,0,116.6-29.1,116.6-29.1c3.2-3.2,6.5,0,9.7,0c3.2,3.2,0,6.5,0,9.7
                  C860,553.2,817.9,585.6,737,585.6z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    id="path-18"
                    className={classes.st2}
                    d="M685.2,378.4c0,29.1,22.7,51.8,51.8,51.8s51.8-22.7,51.8-51.8c0-29.1-22.7-51.8-51.8-51.8
                  S685.2,349.3,685.2,378.4z M698.1,378.4c0-22.7,16.2-38.9,38.9-38.9s38.9,16.2,38.9,38.9c0,22.7-16.2,38.9-38.9,38.9
                  S698.1,401.1,698.1,378.4z"
                  />
                </g>
                <g>
                  <path
                    id="path-18_1_"
                    className={classes.st3}
                    d="M685.2,378.4c0,29.1,22.7,51.8,51.8,51.8s51.8-22.7,51.8-51.8
                  c0-29.1-22.7-51.8-51.8-51.8S685.2,349.3,685.2,378.4z M698.1,378.4c0-22.7,16.2-38.9,38.9-38.9s38.9,16.2,38.9,38.9
                  c0,22.7-16.2,38.9-38.9,38.9S698.1,401.1,698.1,378.4z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    id="path-19"
                    className={classes.st2}
                    d="M711.1,491.7c0,13,13,25.9,25.9,25.9c13,0,25.9-12.9,25.9-25.9c0-12.9-12.9-25.9-25.9-25.9
                  C724.1,465.8,711.1,478.8,711.1,491.7z M724.1,491.7c0-6.5,6.5-13,13-13s12.9,6.5,12.9,13s-6.5,12.9-12.9,12.9
                  C730.5,504.7,724.1,498.2,724.1,491.7z"
                  />
                </g>
                <g>
                  <path
                    id="path-19_1_"
                    className={classes.st3}
                    d="M711.1,491.7c0,13,13,25.9,25.9,25.9c13,0,25.9-12.9,25.9-25.9
                  c0-12.9-12.9-25.9-25.9-25.9C724.1,465.8,711.1,478.8,711.1,491.7z M724.1,491.7c0-6.5,6.5-13,13-13s12.9,6.5,12.9,13
                  s-6.5,12.9-12.9,12.9C730.5,504.7,724.1,498.2,724.1,491.7z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    id="path-20"
                    className={classes.st2}
                    d="M737,384.9c-3.2,0-3.2,0-6.5-3.2L714.3,359c-3.2-3.2,0-6.5,0-9.7c3.2-3.2,6.5,0,9.7,0
                  l16.2,22.7c3.2,3.2,0,6.5,0,9.7S737,384.9,737,384.9L737,384.9z"
                  />
                </g>
                <g>
                  <path
                    id="path-20_1_"
                    className={classes.st3}
                    d="M737,384.9c-3.2,0-3.2,0-6.5-3.2L714.3,359c-3.2-3.2,0-6.5,0-9.7c3.2-3.2,6.5,0,9.7,0
                  l16.2,22.7c3.2,3.2,0,6.5,0,9.7S737,384.9,737,384.9L737,384.9z"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </CustomSvg>
  );
});

export const CustomerSupportIcon: React.FC<CustomSvgProps & SvgIconProps> = React.forwardRef((props, ref) => {
  return (
    <CustomSvg
      {...props}
      ref={ref}
      viewBox={`0 0 ${viewBoxDimension} ${viewBoxDimension}`}
      className={`${props.className} Swyft-icon`}
    >
      <g>
        <path
          d="M1162.5,1359.4c-14.8,0-26.8-12-26.8-26.8v-138.4c0-14.8,12-26.8,26.8-26.8c14.8,0,26.8,12,26.8,26.8
								v138.4C1189.3,1347.4,1177.3,1359.4,1162.5,1359.4z"
        />
        <path
          d="M1161.7,1149c-7.1,0-14-2.8-19-7.8c-5-5-7.8-11.9-7.8-19c0-7.1,2.8-14,7.8-19c5-4.9,11.9-7.8,19-7.8
								c7.1,0,14,2.9,19,7.8c5,5,7.8,11.9,7.8,19c0,7.1-2.8,14-7.8,19C1175.7,1146.1,1168.7,1149,1161.7,1149z"
        />
        <path
          d="M537.3,1355.7c-14.8,0-26.8-12-26.8-26.8V993.1c0-38.8,30.7-70.4,68.4-70.4h544.6
								c36.9,0,65.8,30.9,65.8,70.4v61.2c0,14.8-12,26.8-26.8,26.8c-14.8,0-26.8-12-26.8-26.8v-61.2c0-8.3-4.6-16.8-12.2-16.8H578.9
								c-7.8,0-14.8,8-14.8,16.8v335.9C564.1,1343.7,552.1,1355.7,537.3,1355.7z"
        />
        <path
          d="M856.1,1227.1c-37.5,0-68-30.5-68-68s30.5-68,68-68s68,30.5,68,68S893.6,1227.1,856.1,1227.1z
								 M856.1,1144.7c-7.9,0-14.4,6.5-14.4,14.4c0,7.9,6.5,14.4,14.4,14.4c7.9,0,14.4-6.5,14.4-14.4
								C870.5,1151.2,864,1144.7,856.1,1144.7z"
        />

        <path
          d="M858.6,734.1h-2.7c-57.9,0-92.7-23.4-121.7-48.8c-34.5-30.1-75.5-79-75.5-140.7V360.4
								c0-14.8,12-26.8,26.8-26.8c14.8,0,26.8,12,26.8,26.8v184.3c0,43.8,35.9,81.7,57.2,100.4c25.1,21.9,48.3,35.5,86.4,35.5h2.7
								c39.6,0,63.9-14.3,90.1-37.4c21.3-18.7,56.9-56.3,56.9-98.5V429c0-14.8,12-26.8,26.8-26.8c14.8,0,26.8,12,26.8,26.8v115.6
								c0,60.1-40.8,108.6-75.1,138.7C955.5,708.5,918.3,734.1,858.6,734.1z"
        />

        <path
          d="M854,928.1c-0.3,0-0.6,0-0.9,0c-8-0.3-15.4-4.1-20.3-10.4l-78.2-100.9c-3.6-4.7-5.6-10.5-5.6-16.4v-93.2
								c0-14.8,12-26.8,26.8-26.8c14.8,0,26.8,12,26.8,26.8v84l52.7,68l56.3-63.6V692.9c0-14.8,12-26.8,26.8-26.8
								c14.8,0,26.8,12,26.8,26.8V806c0,6.5-2.4,12.9-6.7,17.8L874,919.1C868.9,924.9,861.6,928.1,854,928.1z"
        />

        <path
          d="M662.3,545.7c-34.2,0-62-27.5-62-61.3v-59.5c0-25.2,16.2-48.3,40.4-57.4c13.9-5.2,29.3,1.8,34.5,15.6
								c5.2,13.9-1.8,29.3-15.6,34.5c-2.8,1-5.7,3.9-5.7,7.2v59.5c0,4,4,7.7,8.4,7.7c1,0,2.3-0.2,2.8-0.3c14.3-3.8,29,4.6,32.8,18.9
								c3.8,14.3-4.7,29-19,32.9C674,545,667.9,545.7,662.3,545.7z"
        />

        <path
          d="M1058.1,545.7c-4.5,0-11.2-0.3-17.1-1.9c-14.3-3.8-22.8-18.6-18.9-32.8c3.8-14.2,18.3-22.6,32.4-19
								c0.5,0.1,1.9,0.2,3.6,0.2c4.5,0,8.9-3.9,8.9-7.8v-22.7c0-14.8,12-26.8,26.8-26.8c14.8,0,26.8,12,26.8,26.8v22.7
								C1120.6,517.6,1092,545.7,1058.1,545.7z"
        />

        <path
          d="M861.6,622.1h-9.4c-15.8,0-31.4-5.7-43.9-16c-11.4-9.4-13.1-26.3-3.6-37.7c9.4-11.4,26.3-13.1,37.7-3.7
								c2.1,1.7,5.5,3.8,9.8,3.8h9.4c4.5,0,8.2-2.6,10.1-4.2c11.2-9.6,28.2-8.4,37.8,2.9c9.6,11.2,8.4,28.2-2.9,37.8
								C893.7,616,877.8,622.1,861.6,622.1z"
        />

        <path
          d="M801.1,459.5h-61.4c-14.8,0-26.8-12-26.8-26.8c0-14.8,12-26.8,26.8-26.8h61.4c14.8,0,26.8,12,26.8,26.8
									C827.9,447.5,815.9,459.5,801.1,459.5z"
        />

        <path
          d="M773.2,480.6c-19.5,0-35.4-15.9-35.4-35.4c0-19.5,15.9-35.4,35.4-35.4c19.5,0,35.4,15.9,35.4,35.4
									C808.6,464.7,792.7,480.6,773.2,480.6z M773.2,427c-10,0-18.2,8.2-18.2,18.2c0,10,8.2,18.2,18.2,18.2"
        />

        <path
          d="M974.6,459.5h-61.4c-14.8,0-26.8-12-26.8-26.8c0-14.8,12-26.8,26.8-26.8h61.4c14.8,0,26.8,12,26.8,26.8
									C1001.4,447.5,989.4,459.5,974.6,459.5z"
        />

        <path
          d="M942.5,480.6c-19.5,0-35.4-15.9-35.4-35.4c0-19.5,15.9-35.4,35.4-35.4c19.5,0,35.4,15.9,35.4,35.4
									C977.9,464.7,962,480.6,942.5,480.6z M942.5,427c-10,0-18.2,8.2-18.2,18.2c0,10,8.2,18.2,18.2,18.2c10,0,18.2-8.2,18.2-18.2
									C960.6,435.2,952.5,427,942.5,427z"
        />
      </g>

      <g>
        <path
          d="M1117.6,466.8c-39.3,0-95.7-9.4-151.3-37C874.1,384,805.8,302.7,763.2,188.2
								c-5.2-13.9,1.9-29.3,15.8-34.5c13.9-5.2,29.3,1.9,34.5,15.8c37.6,101.3,97.1,172.8,176.7,212.3
								c60.5,30,118.6,33.4,143.5,30.6c14.8-1.6,28,9,29.6,23.7c1.6,14.7-9,28-23.7,29.6C1133.1,466.4,1125.7,466.8,1117.6,466.8z"
        />

        <path
          d="M732.4,683.5H585.9c-9.1,0-26.5-6-27-28.9c0-1.7-0.1-3.7-0.1-5.6c-0.2-8-2.8-103.9,1.6-159.2
								c1.4-17,2.2-33,3.2-49.9c2.1-38.1,4.7-85.4,14.3-172.4c14.3-128.8,67.6-196,184.1-231.9c14.2-4.4,29.2,3.6,33.5,17.7
								c4.4,14.1-3.6,29.1-17.7,33.5c-96.3,29.6-134.6,78.4-146.6,186.5c-9.5,85.5-12,132-14.1,169.4c-0.9,17.3-1.8,33.6-3.3,51.2
								c-3.2,39.7-2.5,104.6-1.9,135.8h120.4c14.8,0,26.8,12,26.8,26.8C759.2,671.5,747.2,683.5,732.4,683.5z"
        />

        <path
          d="M631.5,421.9c-7.3,0-14.5-2.9-19.8-8.8c-10-10.9-9.2-27.9,1.8-37.9c39.4-35.9,142.7-143.2,148.3-208.2
								c1.3-14.8,14.3-25.7,29-24.4c14.8,1.3,25.7,14.2,24.4,29c-8.3,97.6-149.5,228.7-165.6,243.3
								C644.4,419.6,637.9,421.9,631.5,421.9z"
        />

        <path
          d="M1145.4,698H974.6c-14.8,0-26.8-12-26.8-26.8c0-14.8,12-26.8,26.8-26.8h144
								c-0.3-133.8-7.2-358.5-7.7-374C1094.4,98.6,956.1,73,875.1,73c-30.7,0-63.1,1.4-92,11.8c-13.9,5-29.3-2.3-34.3-16.2
								c-5-13.9,2.3-29.3,16.2-34.3c36.6-13.1,74.6-14.9,110.1-14.9c169.2,0,274.6,90,289.2,246.8c0.1,0.5,0.1,1.1,0.1,1.6
								c0.1,2.7,8.6,270.9,7.7,403.6C1172.1,686.1,1160.1,698,1145.4,698z"
        />

        <path
          d="M516.8,1344.3c-1.1,0-2.2-0.1-3.3-0.2c-4.6-0.6-113.8-14.9-133.2-108.2
									c-16.8-80.4,103.9-335.2,128.3-385.5c0.1-0.2,0.2-0.3,0.3-0.5c7.6-14.8,34.9-63.8,70.1-74.5c27.7-8.4,158.6-32.1,173.4-34.8
									c14.6-2.6,28.5,7.1,31.1,21.6c2.6,14.6-7.1,28.5-21.6,31.1c-57,10.3-148.6,27.6-167.3,33.3c-8.3,2.5-26.6,25.5-37.9,47.4
									c-57.2,118.2-133.5,305-123.9,350.9c11.6,55.5,86.5,65.8,87.3,65.9c14.6,1.9,25.1,15.3,23.2,29.9
									C541.6,1334.4,530.1,1344.3,516.8,1344.3z"
        />
      </g>

      <g>
        <path
          d="M1196.6,1341.2c-13.4,0-24.9-10-26.6-23.6c-1.8-14.7,8.7-28.1,23.4-29.8c0.7-0.1,75.6-10.4,87.2-65.9
									c9.6-45.9-66.6-232.7-123.9-350.9c-11.3-21.9-29.7-44.9-37.9-47.4c-18.7-5.7-110.3-23.1-167.3-33.3
									c-14.6-2.6-24.3-16.6-21.6-31.1c2.6-14.6,16.6-24.3,31.1-21.6c14.8,2.7,145.7,26.4,173.4,34.8
									c35.2,10.7,62.6,59.7,70.1,74.5c0.1,0.2,0.2,0.3,0.3,0.5c24.4,50.3,145,305,128.3,385.5c-19.4,93.3-128.6,107.6-133.2,108.2
									C1198.8,1341.1,1197.7,1341.2,1196.6,1341.2z"
        />

        <path
          d="M1332.4,1363h-169.9c-14.8,0-26.8-12-26.8-26.8s12-26.8,26.8-26.8h169.9c14.8,0,26.8,12,26.8,26.8
								S1347.2,1363,1332.4,1363z"
        />

        <path
          d="M533.6,1363h-159c-14.8,0-26.8-12-26.8-26.8s12-26.8,26.8-26.8h159c14.8,0,26.8,12,26.8,26.8
								S548.5,1363,533.6,1363z"
        />
      </g>
      <g>
        <path
          d="M349.3,604h-211c-24.4,0-43.5-18.6-43.5-42.4V216.9c0-23.7,19.1-42.3,43.5-42.3h372.4
											c23.8,0,42.4,18.6,42.4,42.3v20.6c0,14.8-12,26.8-26.8,26.8c-14.8,0-26.8-12-26.8-26.8v-9.3H148.5v322.3h200.9
											c14.8,0,26.8,12,26.8,26.8C376.1,592,364.1,604,349.3,604z"
        />

        <path
          d="M479.4,604h-28.9c-14.8,0-26.8-12-26.8-26.8c0-14.8,12-26.8,26.8-26.8h28.9c14.8,0,26.8,12,26.8,26.8
											C506.2,592,494.2,604,479.4,604z"
        />

        <path
          d="M450.5,706.9c-7.3,0-14.4-3-19.6-8.5l-95.2-102.2c-10.1-10.8-9.5-27.8,1.3-37.9
											c10.8-10.1,27.8-9.5,37.9,1.3l48.8,52.3v-34.7c0-14.8,12-26.8,26.8-26.8c14.8,0,26.8,12,26.8,26.8v102.8
											c0,11-6.7,20.9-17,24.9C457.2,706.3,453.8,706.9,450.5,706.9z"
        />
      </g>

      <rect x="188.8" y="278.8" width="274.1" height="53.6" />

      <rect x="188.8" y="366.1" width="274.1" height="53.6" />

      <rect x="188.8" y="452.8" width="187.3" height="53.6" />

      <g>
        <path
          d="M526.4,528.1c-14.8,0-26.8-12-26.8-26.8V298.9c0-14.8,12-26.8,26.8-26.8c14.8,0,26.8,12,26.8,26.8
									v202.4C553.2,516.1,541.2,528.1,526.4,528.1z"
        />
      </g>

      <path
        d="M1132.8,1436.7H572c-36.4,0-66-28.7-66-63.9c0-35.2,29.6-63.9,66-63.9h560.9c36.4,0,66,28.7,66,63.9
								C1198.8,1408,1169.2,1436.7,1132.8,1436.7z M572,1362.4c-6.8,0-12.4,4.6-12.4,10.3c0,5.7,5.5,10.3,12.4,10.3h560.9
								c6.8,0,12.4-4.6,12.4-10.3c0-5.7-5.5-10.3-12.4-10.3H572z"
      />
    </CustomSvg>
  );
});

export const WarrantyIcon12: React.FC<CustomSvgProps & SvgIconProps> = React.forwardRef((props, ref) => {
  return (
    <CustomSvg {...props} ref={ref} viewBox={`0 0 ${128} ${128}`} className={`${props.className} Swyft-icon`}>
      <style>{".prefix__st12{fill:#292845}"}</style>
      <path
        className="prefix__st12"
        d="M64.28 115.58c-.81 0-1.61-.14-2.37-.42-6.55-2.51-28.99-11.74-37.29-31.61-6.2-14.81-5.65-39.07-4.95-48.82.24-4.22 4.15-5.72 6.03-6.48 8.15-3.21 28.3-11.47 35.27-15.26a6.974 6.974 0 016.8 0c6.97 3.8 27.01 12.06 35.09 15.23 1.88.73 5.82 2.27 6.06 6.48.56 9.76 1.22 34.01-4.98 48.79-8.29 19.93-30.56 29.17-37.18 31.68-.79.28-1.63.42-2.48.41zm0-98.69c-.39-.01-.78.09-1.12.28-7.14 3.94-27.15 12.13-35.72 15.51-2.51.98-3 1.6-3.07 2.33-.52 9.41-1.18 32.79 4.63 46.7 7.6 18.09 28.4 26.76 34.6 28.99.48.18 1.01.18 1.5 0 6.13-2.23 27.04-10.91 34.43-28.99 5.82-13.94 5.19-37.29 4.63-46.7 0-.73-.56-1.36-3.07-2.33-8.5-3.48-28.44-11.57-35.62-15.51-.34-.21-.76-.31-1.19-.28z"
      />
      <path
        className="prefix__st12"
        d="M53 74.31h-7.24V54.48l.07-3.26.12-3.56c-1.2 1.2-2.04 1.99-2.51 2.37l-3.94 3.16-3.49-4.36 11.04-8.79H53v34.27zm33.45 0H62.49v-5.04l8.6-8.7c2.55-2.61 4.21-4.42 4.99-5.43s1.34-1.94 1.69-2.8.52-1.75.52-2.67c0-1.38-.38-2.4-1.14-3.07s-1.77-1.01-3.04-1.01c-1.33 0-2.62.3-3.87.91s-2.55 1.48-3.91 2.6l-3.94-4.66c1.69-1.44 3.09-2.45 4.2-3.05s2.32-1.05 3.63-1.37 2.78-.48 4.41-.48c2.14 0 4.03.39 5.67 1.17s2.91 1.88 3.82 3.28 1.36 3.02 1.36 4.83c0 1.58-.28 3.06-.83 4.44s-1.41 2.8-2.58 4.25-3.21 3.52-6.15 6.21l-4.41 4.15v.33h14.93v6.11zM49.65 86.77l-2.48-7.15h-.05c.07 1.06.1 2.06.1 2.99v4.17h-1.27V78.2h1.97l2.38 6.81h.04l2.45-6.81h1.98v8.57h-1.35v-4.24c0-.43.01-.98.03-1.66s.04-1.1.06-1.24h-.05l-2.57 7.14h-1.24zm12.97-3.25c0 1.06-.27 1.88-.81 2.48s-1.3.89-2.27.89c-.61 0-1.14-.14-1.61-.41s-.82-.67-1.07-1.18-.38-1.11-.38-1.78c0-1.05.27-1.87.81-2.46s1.3-.88 2.28-.88c.94 0 1.68.3 2.23.91s.82 1.41.82 2.43zm-4.71 0c0 1.5.55 2.24 1.66 2.24 1.09 0 1.64-.75 1.64-2.24 0-1.48-.55-2.22-1.65-2.22-.58 0-1 .19-1.26.57s-.39.93-.39 1.65zm12 3.25h-1.38v-3.98c0-.5-.1-.87-.3-1.12s-.52-.37-.96-.37c-.58 0-1.01.17-1.28.52s-.4.92-.4 1.73v3.23H64.2V80.3h1.08l.19.85h.07c.2-.31.47-.55.83-.71s.76-.25 1.2-.25c1.55 0 2.33.79 2.33 2.37v4.21zm4.33-1c.34 0 .67-.05 1.01-.16v1.04c-.15.07-.35.12-.59.17s-.49.07-.75.07c-1.3 0-1.96-.69-1.96-2.06v-3.49h-.88v-.61l.95-.5.47-1.37h.85v1.44h1.85v1.04h-1.85v3.47c0 .33.08.58.25.74s.38.22.65.22zm8 1h-1.38v-3.98c0-.5-.1-.87-.3-1.12s-.52-.37-.96-.37c-.58 0-1 .17-1.27.52s-.41.92-.41 1.74v3.22h-1.38v-9.12h1.38v2.31c0 .37-.02.77-.07 1.19h.09c.19-.31.45-.55.78-.73s.72-.26 1.17-.26c1.57 0 2.36.79 2.36 2.37v4.23zm6.27-1.84c0 .63-.23 1.12-.69 1.46s-1.12.51-1.98.51c-.86 0-1.56-.13-2.08-.39v-1.19c.76.35 1.47.53 2.13.53.85 0 1.27-.26 1.27-.77 0-.16-.05-.3-.14-.41s-.25-.22-.46-.34-.51-.25-.9-.4c-.75-.29-1.25-.58-1.51-.87s-.4-.66-.4-1.12c0-.55.22-.99.67-1.29s1.06-.46 1.83-.46c.76 0 1.48.15 2.16.46l-.45 1.04c-.7-.29-1.29-.43-1.76-.43-.73 0-1.09.21-1.09.62 0 .2.09.38.28.52s.6.33 1.24.58c.54.21.92.4 1.17.57s.42.37.54.59.17.47.17.79z"
      />
    </CustomSvg>
  );
});

export const WarrantyIcon24: React.FC<CustomSvgProps & SvgIconProps> = React.forwardRef((props, ref) => {
  return (
    <CustomSvg {...props} ref={ref} viewBox={`0 0 ${128} ${128}`} className={`${props.className} Swyft-icon`}>
      <style>{".prefix__st24{fill:#292845}"}</style>
      <path
        className="prefix__st24"
        d="M64.28 115.58c-.81 0-1.61-.14-2.37-.42-6.55-2.51-28.99-11.74-37.29-31.61-6.2-14.81-5.65-39.07-4.95-48.82.24-4.22 4.15-5.72 6.03-6.48 8.15-3.21 28.3-11.47 35.27-15.26a6.974 6.974 0 016.8 0c6.97 3.8 27.01 12.06 35.09 15.23 1.88.73 5.82 2.27 6.06 6.48.56 9.76 1.22 34.01-4.98 48.79-8.29 19.93-30.56 29.17-37.18 31.68-.79.28-1.63.42-2.48.41zm0-98.69c-.39-.01-.78.09-1.12.28-7.14 3.94-27.15 12.13-35.72 15.51-2.51.98-3 1.6-3.07 2.33-.52 9.41-1.18 32.79 4.63 46.7 7.6 18.09 28.4 26.76 34.6 28.99.48.18 1.01.18 1.5 0 6.13-2.23 27.04-10.91 34.43-28.99 5.82-13.94 5.19-37.29 4.63-46.7 0-.73-.56-1.36-3.07-2.33-8.5-3.48-28.44-11.57-35.62-15.51-.34-.21-.76-.31-1.19-.28z"
      />
      <path
        className="prefix__st24"
        d="M49.65 86.77l-2.48-7.15h-.05c.07 1.06.1 2.06.1 2.99v4.17h-1.27V78.2h1.97l2.38 6.81h.04l2.45-6.81h1.98v8.57h-1.35v-4.24c0-.43.01-.98.03-1.66s.04-1.1.06-1.24h-.05l-2.57 7.14h-1.24zM62.62 83.52c0 1.06-.27 1.88-.81 2.48s-1.3.89-2.27.89c-.61 0-1.14-.14-1.61-.41s-.82-.67-1.07-1.18-.38-1.11-.38-1.78c0-1.05.27-1.87.81-2.46s1.3-.88 2.28-.88c.94 0 1.68.3 2.23.91s.82 1.41.82 2.43zm-4.71 0c0 1.5.55 2.24 1.66 2.24 1.09 0 1.64-.75 1.64-2.24 0-1.48-.55-2.22-1.65-2.22-.58 0-1 .19-1.26.57s-.39.93-.39 1.65zM69.91 86.77h-1.38v-3.98c0-.5-.1-.87-.3-1.12s-.52-.37-.96-.37c-.58 0-1.01.17-1.28.52s-.4.92-.4 1.73v3.23H64.2V80.3h1.08l.19.85h.07c.2-.31.47-.55.83-.71s.76-.25 1.2-.25c1.55 0 2.33.79 2.33 2.37v4.21zM74.24 85.77c.34 0 .67-.05 1.01-.16v1.04c-.15.07-.35.12-.59.17s-.49.07-.75.07c-1.3 0-1.96-.69-1.96-2.06v-3.49h-.88v-.61l.95-.5.47-1.37h.85v1.44h1.85v1.04h-1.85v3.47c0 .33.08.58.25.74s.38.22.65.22zM82.24 86.77h-1.38v-3.98c0-.5-.1-.87-.3-1.12s-.52-.37-.96-.37c-.58 0-1 .17-1.27.52s-.41.92-.41 1.74v3.22h-1.38v-9.12h1.38v2.31c0 .37-.02.77-.07 1.19h.09c.19-.31.45-.55.78-.73s.72-.26 1.17-.26c1.57 0 2.36.79 2.36 2.37v4.23zM88.51 84.93c0 .63-.23 1.12-.69 1.46s-1.12.51-1.98.51c-.86 0-1.56-.13-2.08-.39v-1.19c.76.35 1.47.53 2.13.53.85 0 1.27-.26 1.27-.77 0-.16-.05-.3-.14-.41s-.25-.22-.46-.34-.51-.25-.9-.4c-.75-.29-1.25-.58-1.51-.87s-.4-.66-.4-1.12c0-.55.22-.99.67-1.29s1.06-.46 1.83-.46c.76 0 1.48.15 2.16.46l-.45 1.04c-.7-.29-1.29-.43-1.76-.43-.73 0-1.09.21-1.09.62 0 .2.09.38.28.52s.6.33 1.24.58c.54.21.92.4 1.17.57s.42.37.54.59.17.47.17.79z"
      />
      <g>
        <path
          className="prefix__st24"
          d="M59.56 74.8H35.61v-5.04l8.6-8.7c2.55-2.61 4.21-4.42 4.99-5.43s1.34-1.94 1.69-2.8.52-1.75.52-2.67c0-1.38-.38-2.4-1.14-3.07s-1.77-1.01-3.04-1.01c-1.33 0-2.62.3-3.87.91s-2.55 1.48-3.91 2.6l-3.94-4.66c1.69-1.44 3.09-2.45 4.2-3.05s2.32-1.05 3.63-1.37 2.78-.48 4.41-.48c2.14 0 4.03.39 5.67 1.17s2.91 1.88 3.82 3.28 1.36 3.02 1.36 4.83c0 1.58-.28 3.06-.83 4.44s-1.41 2.8-2.58 4.25-3.21 3.52-6.15 6.21l-4.41 4.15v.33h14.93v6.11zM87.73 67.7h-4.12v7.1h-7.08v-7.1H61.9v-5.04l15.02-22.12h6.68v21.54h4.12v5.62zm-11.2-5.63v-5.81c0-.97.04-2.38.12-4.22s.14-2.91.19-3.21h-.19c-.58 1.28-1.27 2.53-2.09 3.75l-6.28 9.49h8.25z"
        />
      </g>
    </CustomSvg>
  );
});

export const CreditCardIcon: React.FC<CustomSvgProps & SvgIconProps> = React.forwardRef((props, ref) => {
  return (
    <CustomSvg
      {...props}
      ref={ref}
      viewBox={`0 0 ${newViewBoxDimension} ${newViewBoxDimension}`}
      className={`${props.className} Swyft-icon`}
    >
      <path
        d="M164.7,294.3h58.6c5.8,0,10.5,4.7,10.5,10.5v29.7c0,5.8-4.7,10.5-10.5,10.5h-58.6c-5.8,0-10.5-4.7-10.5-10.5
        v-29.7C154.1,299.1,158.9,294.3,164.7,294.3L164.7,294.3z M391,115.6L68.5,202l31.2,116.6V218.3l0,0l0-0.4l0-0.4l0,0l0-0.4v0l0-0.4
        v0l0.1-0.8v0l0-0.4v0c0.6-7.2,3.9-13.7,8.7-18.6l0,0l0.3-0.3l0,0l0.3-0.2l0,0l0.3-0.2v0l0.3-0.2l0,0l0.3-0.2v0l0.3-0.2l0,0l0.3-0.2
        v0l0.3-0.2l0,0l0.3-0.2l0,0l0.3-0.2l0,0l0.3-0.2v0l0.3-0.2v0l0.3-0.2l0,0l0.3-0.2l0,0l0.3-0.2v0l0.3-0.2l0,0l0.3-0.2l0,0l0.3-0.2
        l0,0l0.6-0.4l0,0c0.3-0.2,0.6-0.4,0.9-0.5l0,0l0.3-0.2v0l0.3-0.2l0,0l0.3-0.2v0l0.7-0.3l0,0l0.3-0.2l0,0l0.3-0.2l0,0l0.3-0.2l0,0
        l0.3-0.1v0l0.3-0.1l0,0l0.7-0.3v0c3.3-1.3,6.9-2,10.7-2h280.5L391,115.6L391,115.6z M57.7,161.7l322.4-86.4l-3.4-12.7
        c-1-3.6-4.7-5.8-8.3-4.8L59.1,140.7c-3.5,0.9-5.9,4.9-4.8,8.3L57.7,161.7L57.7,161.7z M434.6,188.2h15.6
        c16.5,0,30.1,13.6,30.1,30.1v215.8c0,16.6-13.5,30.1-30.1,30.1H129.9c-16.5,0-30.1-13.6-30.1-30.1v-35.6c-2.6-3.3-4.6-7-5.7-11.1
        L31.8,155.1c-5.1-15.3,6-32.8,21.3-36.9l309.3-82.9c16-4.3,32.6,5.3,36.9,21.3L434.6,188.2L434.6,188.2z M129.9,211.6
        c-0.4,0-0.7,0-1.1,0.1l0,0l-0.3,0.1v0l-0.4,0.1l0,0l-0.2,0.1l0,0l-0.2,0.1l0,0l-0.1,0l0,0l-0.2,0.1v0l-0.1,0l0,0l-0.1,0l0,0
        l-0.2,0.1l0,0l-0.1,0l0,0l-0.2,0.1l0,0l-0.1,0l0,0l-0.1,0.1l0,0l-0.1,0l0,0l-0.1,0l0,0l-0.1,0l0,0l-0.1,0v0l-0.1,0l0,0l-0.1,0v0
        l-0.1,0l0,0l-0.1,0l0,0l-0.1,0l0,0l-0.1,0l0,0l-0.1,0.1l0,0l-0.1,0l0,0l-0.1,0.1l0,0l-0.1,0l0,0l-0.1,0.1l0,0l-0.1,0.1l0,0
        l-0.1,0.1l0,0l-0.1,0.1v0l-0.1,0v0l-0.1,0.1l0,0l-0.1,0.1l0,0l-0.1,0.1l0,0l-0.1,0.1l0,0l-0.1,0.1l0,0l0,0c-1.1,1.1-1.8,2.6-2,4.2
        v0l0,0.1v0l0,0.1v0l0,0.1v0v0.1l0,0l0,0.1l0,0v0.1l0,0v0.1l0,0v215.8c0,3.8,3,6.8,6.8,6.8h320.2c3.7,0,6.8-3.1,6.8-6.8V218.3
        c0-3.8-3-6.8-6.8-6.8C343.4,211.6,236.6,211.6,129.9,211.6z M250.2,393.9h179.3v22.7H250.2V393.9z M288.7,353.4h140.8V376H288.7
        V353.4z"
      />
    </CustomSvg>
  );
});

export const ScheduleEventAddIcon: React.FC<CustomSvgProps & SvgIconProps> = React.forwardRef((props, ref) => {
  return (
    <CustomSvg
      {...props}
      ref={ref}
      style={{
        height: "85px",
        width: "72px"
      }}
      viewBox={`0 0 ${60} ${72}`}
      className={`${props.className} Swyft-icon`}
    >
      <title>{"icon_timeout"}</title>
      <defs>
        <filter colorInterpolationFilters="auto" id="prefix__a">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.968627 0 0 0 0 0.505882 0 0 0 0 0.360784 0 0 0 1.000000 0"
          />
        </filter>
        <filter colorInterpolationFilters="auto" id="prefix__b">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.294118 0 0 0 0 0.329412 0 0 0 0 0.384314 0 0 0 1.000000 0"
          />
        </filter>
        <filter colorInterpolationFilters="auto" id="prefix__c">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.294118 0 0 0 0 0.329412 0 0 0 0 0.384314 0 0 0 1.000000 0"
          />
        </filter>
      </defs>
      <g filter="url(#prefix__a)" fill="none" fillRule="evenodd">
        <g filter="url(#prefix__b)">
          <path
            d="M41 55.512v1.854L26.143 62l-13-3.596v2.67H2V40.682h14.801l11.44 4.263a5.358 5.358 0 013.473 5.005h3.715A5.559 5.559 0 0141 55.512zM9.429 57.366V44.39H5.714v12.976H9.43zm27.671-2.65a1.871 1.871 0 00-1.671-1.039h-9.936a9.271 9.271 0 01-2.934-.482l-4.42-1.464 1.17-3.522 4.42 1.464c.575.186 4.271.278 4.271.278a1.65 1.65 0 00-1.059-1.538L16.133 44.39h-2.99v10.158l12.944 3.578 11.013-3.41z"
            fill="#000"
            fillRule="nonzero"
          />
        </g>
        <g filter="url(#prefix__c)">
          <g fill="#000" fillRule="nonzero">
            <path d="M27.476 14.8v10.8l8.505 5.22 1.448-2.16-7.239-4.32V14.8z" />
            <path d="M41.808 22c.09.594.144 1.188.144 1.8 0 7.02-5.61 12.6-12.666 12.6-7.057 0-12.667-5.58-12.667-12.6s5.61-12.6 12.667-12.6c1.266 0 2.479.18 3.619.522V8.014a15.93 15.93 0 00-3.62-.414C20.239 7.6 13 14.8 13 23.8S20.238 40 29.286 40c9.047 0 16.285-7.2 16.285-16.2 0-.612-.036-1.206-.108-1.8h-3.655z" />
            <path d="M45.571 9.4V4h-3.619v5.4h-5.428V13h5.428v5.4h3.62V13H51V9.4z" />
          </g>
        </g>
      </g>
    </CustomSvg>
  );
});

export const LogoSwyftWhyte = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 267 114" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
        <path id="prefix__a" d="M.068 0H199.83v113.437H.07z" />
        <path id="prefix__c" d="M.008.05h266.354v83.393H.008z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(67.056)">
          <mask id="prefix__b" fill="#fff">
            <use xlinkHref="#prefix__a" />
          </mask>
          <path
            fill="#FFF"
            mask="url(#prefix__b)"
            d="M100.665 100.055h10.495v2.788h-7.667v2.477h4.217v2.79h-4.217v2.55h7.667v2.79h-10.495v-13.395M128.854 100.055v13.394h-2.826l-5.284-8.33v8.33h-2.826v-13.394h2.826l5.284 8.33v-8.33h2.826M136.052 100.055h10.495v2.788h-7.668v2.477h4.218v2.79h-4.218v2.55h7.668v2.79h-10.495v-13.395M156.167 106.806h2.974c1.173 0 1.98-.824 1.98-1.98 0-1.157-.807-1.983-1.963-1.983h-2.991v3.963zm2.22 2.772h-2.22v3.871h-2.862v-13.394h5.78c2.862 0 4.899 2.019 4.899 4.77 0 1.908-.99 3.486-2.569 4.257l2.826 4.367h-3.357l-2.496-3.87zM183.547 106.366v.551c0 3.89-2.64 6.734-6.623 6.734-4.02 0-6.808-2.918-6.808-6.9 0-3.87 2.9-6.898 6.917-6.898 2.661 0 4.826 1.321 6 3.34l-2.422 1.54c-.66-1.228-1.962-2.055-3.578-2.055-2.366 0-4.055 1.78-4.055 4.073 0 2.442 1.56 4.166 3.982 4.166 1.633 0 2.808-.734 3.414-1.908h-4.314v-2.643h7.487M192.416 109.137l-4.551-9.082h3.083l2.917 5.852 2.918-5.852h3.046l-4.551 9.01v4.384h-2.862v-4.312M25.257 49.265l-6.9-19.221H.068l16.17 43.897 9.019-24.676M149.355 46.121V30.044H134.56v-8.97c0-3.028 1.864-4.659 4.777-4.659h10.017V-.01h-13.163c-11.415 0-18.871 6.99-18.871 18.289v11.765h-11.649v16.077h43.683"
          />
        </g>
        <path
          fill="#FFF"
          d="M117.465 55.482l7.183 19.893 9.281-25.395-7.01-19.936h-18.505l-10.628 29.08-.957 2.721-.019-.052-8.96 24.516.43 1.164h17.635l11.55-31.991"
        />
        <g transform="translate(.269 29.994)">
          <mask id="prefix__d" fill="#fff">
            <use xlinkHref="#prefix__c" />
          </mask>
          <path
            fill="#FFF"
            mask="url(#prefix__d)"
            d="M184.108 58.76h17.24V24.65h-17.24zM63.37 31.967c0-11.649-6.756-20.036-17.823-23.297-2.065-.611-4.109-1.004-6.098-1.28l-6.256 17.116c2.569.275 4.903.626 6.763 1.287 2.912 1.049 5.475 3.379 5.475 7.223 0 5.475-4.777 9.785-13.28 9.785-8.155 0-14.212-4.077-14.212-10.251H0c0 16.308 13.63 27.49 31.918 27.49 18.871 0 31.451-11.764 31.451-28.073M248.307 36.044V24.651h-17.124V39.19c0 11.882 8.155 19.57 20.035 19.57h15.144V42.336h-11.648c-3.845 0-6.407-2.447-6.407-6.29M150.023.05l-24.956 68.28-5.407 15.125h18.055L167.77.05h-17.746"
          />
        </g>
        <path
          fill="#FFF"
          d="M266.63 46.121V30.044h-18.054V17.696h-9.436l-16.192 19.92v8.505h43.683M18.44 52.41c2.024.56 4.146.926 6.27 1.201l6.235-17.059c-2.517-.232-4.818-.55-6.796-1.266-3.145-1.165-5.242-3.378-5.242-6.64 0-5.009 4.659-8.97 12.347-8.97 7.572 0 12.814 3.611 13.047 9.203h18.056c0-15.726-13.046-26.443-30.87-26.443C13.432 2.436.968 13.852.968 29.578c0 11.067 6.173 19.686 17.473 22.832"
        />
      </g>
    </svg>
  );
};
